import { Outlet } from 'react-router-dom';
import { withAuth } from '../withAuth';
import { withBroadcastChannel } from '../withBroadcastChannel';
import { PermissionsProvider } from '../provider/PermissionsProvider';

const RootContainer: React.FC = () => {
  return <PermissionsProvider><Outlet /></PermissionsProvider>;
};

export default withAuth(withBroadcastChannel(RootContainer));
